export const demoData = getData();

function getData() {
    const now = new Date();
    return getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-6)).concat(
        getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-5)),
        getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-4)),
        getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-3)),
        getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-2)),
        getDayData(new Date(now.getFullYear(),now.getMonth(),now.getDate()-1)),
        getDayData(now),
    )
}

function getDayData(date: Date) {
    const dayOfWeek = date.getDay();
    return dayOfWeek > 0 && dayOfWeek < 6 ? 
        weekDay(date.getFullYear(), date.getMonth(), date.getDate()) : 
        weekendDay(date.getFullYear(), date.getMonth(), date.getDate());
}


function weekDay(year: number, month: number, day: number) {
    return [
        {
            x: new Date(year, month, day, 0, 0, 0),
            y: 15
        },
        {
            x: new Date(year, month, day, 7, 0, 0),
            y: 17
        },
        {
            x: new Date(year, month, day, 7, 45, 0),
            y: 65
        },
        {
            x: new Date(year, month, day, 10, 0, 0),
            y: 70
        },
        {
            x: new Date(year, month, day, 10, 45, 0),
            y: 50
        },
        {
            x: new Date(year, month, day, 11, 30, 0),
            y: 45
        },
        {
            x: new Date(year, month, day, 18, 30, 0),
            y: 45
        },
        {
            x: new Date(year, month, day, 19, 0, 0),
            y: 18
        },
        {
            x: new Date(year, month, day, 22, 0, 0),
            y: 15
        },
    ]
}

function weekendDay(year: number, month: number, day: number) {
    return [
        {
            x: new Date(year, month, day, 0, 0, 0),
            y: 15
        },
        {
            x: new Date(year, month, day, 7, 0, 0),
            y: 17
        },
        {
            x: new Date(year, month, day, 22, 0, 0),
            y: 15
        },
    ]
}